var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.813,
    height: 54.813,
    viewBox: "0 0 54.813 54.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "remove",
    d: "M62.313,13.02,56.792,7.5,34.906,29.386,13.02,7.5,7.5,13.02,29.386,34.906,7.5,56.792l5.52,5.52L34.906,40.427,56.792,62.313l5.52-5.52L40.427,34.906Z",
    transform: "translate(-7.5 -7.5)",
    fill: "#2389d0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.9c873168f6e8a769efa0c7e432b23f3b.svg";
export { ForwardRef as ReactComponent };